// Constants
import { LoggingStrings } from "@ms/uno-constants/lib/local/LoggingConstants";
// Errors
import { ErrorUtilities } from "@ms/uno-errors/lib/local/utilities/ErrorUtilities";
// Telemetry
import { resetLogHandler } from "../local/utilities/LogUtilities";
import { TraceLevel } from "./events/Trace.event";
import { CoreTelemetryLogger } from "./loggers/CoreTelemetryLogger";
import { EngagementLogger } from "./loggers/EngagementLogger";
import { PerformanceLogger } from "./loggers/PerformanceLogger";
import { TraceEventLogger } from "./loggers/TraceEventLogger";
import { UnhandledErrorHandler } from "./UnhandledErrorHandler";
import { UTelLogHandler } from "./UTelLogHandler";
import { scrubUrls } from "./utilities/UrlScrubber";
import { getCoreTelemetryWorkload } from "./utilities/CoreTelemetryUtilities";
/** Logger manager to manage log handler for the app */ export class LoggerManager {
    /**
     * Get log handler to send events
     */ getLoggers() {
        return {
            logHandler: this.logHandler,
            traceLogger: this.traceEventLogger,
            engagementLogger: this.engagementLogger,
            coreTelemetryLogger: this.coreTelemetryLogger,
            performanceLogger: this.performanceLogger
        };
    }
    constructor(telemetryContext, privacyGuardContext, configProvider, appName){
        this.logHandler = new UTelLogHandler();
        this.configProvider = configProvider;
        resetLogHandler(telemetryContext, privacyGuardContext, this.logHandler, this.configProvider, appName);
        const { traceLogThreshold, blockedTraceTags } = this.configProvider().settings;
        const tracelevel = traceLogThreshold || TraceLevel.Info;
        const blockedTags = blockedTraceTags || [];
        this.traceEventLogger = new TraceEventLogger(tracelevel, this.logHandler, blockedTags);
        this.engagementLogger = new EngagementLogger(this.logHandler, this.traceEventLogger);
        this.coreTelemetryLogger = new CoreTelemetryLogger(this.logHandler);
        const { clientType, clientFlavor } = this.configProvider().sessionMetaData.appMetadata;
        const surface = getCoreTelemetryWorkload(clientType, clientFlavor);
        if (appName === LoggingStrings.ProductNameV2) {
            this.coreTelemetryLogger.setPersistentContext({
                workload: surface.workload,
                subWorkload: surface.subWorkload,
                licenseType: "",
                hasCopilotLicense: "",
                isCopilotEnabled: ""
            });
        }
        this.performanceLogger = new PerformanceLogger(this.logHandler);
        UnhandledErrorHandler.registerUnhandledErrorHandler(this.traceEventLogger, configProvider().changeGates.DisableCallStackInUnhandledErrorLog);
        // Wire up EUII scrubbing for error messages flowing through ErrorUtilities
        ErrorUtilities.setRedactionFunction(scrubUrls);
    }
}
